import { useEffect, useState } from "react";
import organizationsService from "services/organizations.service";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import MDBox from "components/MDBox";
import MDTypograhy from "components/MDTypography";

export default function SelectOrganization({
    changeHandler,
    selectedOrganization,
    error
}) {
    const [organizations, setOrganizations] = useState([]);
    const [selectedOrgId, setSelectedOrgId] = useState("");

    useEffect(() => {
        (async () => {
            try {
                const orgsResponse = await organizationsService.getOrganizations();
                const mapped = orgsResponse.map((m) => ({
                    id: m._id,
                    label: m.name,
                }))
                setOrganizations(mapped);
            } catch (error) {
                console.error("Error fetching organizations: ", error);
            }
        })();
    }, [])

    useEffect(() => {
        if (selectedOrganization && selectedOrganization._id) {
            setSelectedOrgId(selectedOrganization._id);
        }
    }, [selectedOrganization]);

    // Handle organization selection change 
    const handleOrgChange = (e) => {
        const selectedId = e.target.value;
        setSelectedOrgId(selectedId);
        const selected = organizations.find((o) => o.id === selectedId);
        const update = {
            organization: selectedId,
            organizationName: selected?.label ?? ""
        };
        changeHandler(update);
    }

    return (
        <MDBox>
            <FormControl fullWidth>
                <InputLabel error={error} id="organization-select-label">Organization</InputLabel>
                <Select
                    label="Organization"
                    labelId="organization-select-label"
                    variant="outlined"
                    name="organization"
                    value={selectedOrgId}
                    onChange={handleOrgChange}
                    error={error}
                    helperText={error}
                    fullWidth
                    renderValue={(selected) => {
                        const found = organizations.find((o) => o.id === selected);
                        return found ? found.label : "";
                    }}
                    sx={{ height: '45px', maxWidth: '100%', '& .MuiSelect-select': { paddingY: '8px' } }}
                >
                    {organizations.map((org) => (
                        <MenuItem key={org.id} value={org.id}>
                            {org.label}
                        </MenuItem>
                    ))}
                </Select>
                {error && (
                        <MDTypograhy ml={2} mt={0.1} variant="caption" color="error">
                            {error}
                        </MDTypograhy>
                )}
            </FormControl>
        </MDBox>
    )
}